export let cdn = (src: string) => {
  return new Promise((resolve, reject) => {
    let script: HTMLScriptElement = document.createElement("script");
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
    script.onload = resolve;
  });
};
